import * as React from "react";
import * as ReactDOM from "react-dom/client";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import App from "./App";
import theme from "./theme";
import en from "./i18n/en.json";
import sk from "./i18n/sk.json";
import tw from "./i18n/tw.json";
import ua from "./i18n/ua.json";
import de from "./i18n/de.json";


import { Talkr } from "talkr";
import InvitationDialog from "./InvitationDialog";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PalenkaDialog from "./palenkaDialog";
import ThankYouDialog from "./thankYouDialog";
import config from "./config";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement!);

root.render(
  <Talkr languages={{ en, sk, tw, ua, de }} defaultLanguage="sk">
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route
            path={config.uripaths.weddingPartyAfter9PMPath}
            element={
              <>
                <InvitationDialog />
                <App />
              </>
            }
          />
          <Route
            path={config.uripaths.palenkaPath}
            element={
              <>
                <PalenkaDialog />
                <App />
              </>
            }
          />
          <Route
            path={config.uripaths.thankYouPath}
            element={
              <>
                <ThankYouDialog />
                <App />
              </>
            }
          />
          <Route
            path="*"
            element={
              <>
                <App />
              </>
            }
          ></Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  </Talkr>
);
